// import {
//   Autocomplete,
//   Box,
//   Button,
//   CircularProgress,
//   Grid,
//   TextField,
//   Typography,
//   Snackbar,
//   Alert,
// } from "@mui/material";
// import React, { useState } from "react";
// import debounce from "lodash.debounce";

// import axios from "axios";

// export default function SendnotificationByPinCode(
//   sendnotificationopenmodel,
//   setSendnotificationopenmodel
// ) {
//   const [snackbar, setSnackbar] = useState({
//     open: false,
//     message: "",
//     severity: "success", // or "error"
//   });
//   const [formData, setFormData] = useState({
//     pincodes: [],
//     title: "",
//     body: "",
//   });

//   const [pincodes, setPincodes] = useState([]);
//   const [pincodeLoading, setPincodeLoading] = useState(false);
//   const [fieldErrors, setFieldErrors] = useState({});
//   const [submitting, setSubmitting] = useState(false);

//   const fetchPincodes = debounce(async (searchTerm) => {
//     if (!searchTerm) return;
//     setPincodeLoading(true);
//     try {
//       const response = await axios.get(
//         `https://api.medstown.com/offer/pincode?search=${searchTerm}`
//       );
//       setPincodes(response.data);
//     } catch (err) {
//       console.error("Error fetching pincodes:", err);
//     } finally {
//       setPincodeLoading(false);
//     }
//   }, 500);

//   // const handleSubmit = async () => {
//   //   const payload = {
//   //     pincodeArray: formData.pincodes,
//   //     title: formData.title,
//   //     body: formData.body,
//   //   };

//   //   console.log("Payload to send:", payload);

//   //   setSubmitting(true);
//   //   try {
//   //     const response = await axios.post(
//   //       "https://api.medstown.com/customer/pincodes-notification",
//   //       payload
//   //     );
//   //     console.log("API Response:", response.data);
//   //     alert("Notification sent successfully!");
//   //   } catch (error) {
//   //     console.error("Error sending notification:", error);
//   //     alert("Failed to send notification.");
//   //   } finally {
//   //     setSubmitting(false);
//   //   }
//   // };

//   const handleSubmit = async () => {
//     const payload = {
//       pincodeArray: formData.pincodes.map((item) =>
//         typeof item === "object" ? item.areaPincode : Number(item)
//       ),
//       title: formData.title,
//       body: formData.body,
//     };

//     console.log("Payload to send:", payload);

//     setSubmitting(true);
//     try {
//       const response = await axios.post(
//         "https://api.medstown.com/customer/pincodes-notification",
//         payload
//       );
//       console.log("API Response:", response.data);

//       // Show Material UI toast (Snackbar)
//       setSnackbar({
//         open: true,
//         message: `✅ ${response.data.message} (✔ ${response.data.successCount}, ❌ ${response.data.failureCount})`,
//         severity: "success",
//       });
//     } catch (error) {
//       console.error("Error sending notification:", error);
//       setSnackbar({
//         open: true,
//         message: "❌ Failed to send notification.",
//         severity: "error",
//       });
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   return (
//     <>
//       <Snackbar
//         open={snackbar.open}
//         autoHideDuration={6000}
//         onClose={() => setSnackbar({ ...snackbar, open: false })}
//         anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
//       >
//         <Alert
//           onClose={() => setSnackbar({ ...snackbar, open: false })}
//           severity={snackbar.severity}
//           variant="filled"
//           sx={{ width: "100%" }}
//         >
//           {snackbar.message}
//         </Alert>
//       </Snackbar>

//       <Box p={3}>
//         <Typography variant="h6" gutterBottom>
//           Send Notification by Pincode
//         </Typography>
//         {/* <Button
//         variant="outlined"
//         onClick={() => setSendnotificationopenmodel(false)}
//       >
//         x
//       </Button> */}
//         <Grid container spacing={2}>
//           {/* <Grid item xs={12}>
//           <Autocomplete
//             multiple
//             options={pincodes}
//             getOptionLabel={(option) => `${option.areaPincode}`}
//             onInputChange={(_, value) => fetchPincodes(value)}
//             onChange={(_, selectedPincodes) =>
//               setFormData((prev) => ({
//                 ...prev,
//                 pincodes: selectedPincodes.map((area) => area.areaPincode),
//               }))
//             }
//             loading={pincodeLoading}
//             renderInput={(params) => (
//               <TextField
//                 {...params}
//                 label="Select Pincodes"
//                 variant="outlined"
//                 InputProps={{
//                   ...params.InputProps,
//                   endAdornment: (
//                     <>
//                       {pincodeLoading ? <CircularProgress size={20} /> : null}
//                       {params.InputProps.endAdornment}
//                     </>
//                   ),
//                 }}
//               />
//             )}
//           />
//         </Grid> */}
//           <Grid item xs={12}>
//             <Autocomplete
//               multiple
//               freeSolo
//               filterSelectedOptions
//               options={pincodes}
//               getOptionLabel={(option) =>
//                 typeof option === "string"
//                   ? option
//                   : `${option.areaPincode} - ${
//                       option.areaName || option.type || "Area"
//                     }`
//               }
//               onInputChange={(_, value) => fetchPincodes(value)}
//               onChange={(_, selectedOptions) => {
//                 // Handle both existing objects and manually typed pincodes
//                 const formatted = selectedOptions.map((item) => {
//                   if (typeof item === "string") {
//                     // User manually entered a pincode
//                     return {
//                       areaPincode: parseInt(item),
//                       areaName: "Custom",
//                       type: "Manual",
//                     };
//                   }
//                   return item; // From fetched API
//                 });

//                 setFormData((prev) => ({
//                   ...prev,
//                   pincodes: formatted,
//                 }));
//               }}
//               loading={pincodeLoading}
//               renderInput={(params) => (
//                 <TextField
//                   {...params}
//                   label="Select Pincodes"
//                   variant="outlined"
//                   InputProps={{
//                     ...params.InputProps,
//                     endAdornment: (
//                       <>
//                         {pincodeLoading ? <CircularProgress size={20} /> : null}
//                         {params.InputProps.endAdornment}
//                       </>
//                     ),
//                   }}
//                 />
//               )}
//             />
//           </Grid>
//           <Grid item xs={6}>
//             <TextField
//               fullWidth
//               label="Title"
//               value={formData.title}
//               onChange={(e) =>
//                 setFormData((prev) => ({ ...prev, title: e.target.value }))
//               }
//             />
//           </Grid>

//           <Grid item xs={6}>
//             <TextField
//               fullWidth
//               label="Body"
//               value={formData.body}
//               onChange={(e) =>
//                 setFormData((prev) => ({ ...prev, body: e.target.value }))
//               }
//             />
//           </Grid>

//           <Grid item xs={12}>
//             <Button
//               variant="contained"
//               color="primary"
//               onClick={handleSubmit}
//               disabled={submitting}
//             >
//               {submitting ? "Sending..." : "Send Notification"}
//             </Button>
//           </Grid>
//         </Grid>
//       </Box>
//     </>
//   );
// }

// import React, { useState } from "react";
// import {
//   Autocomplete,
//   Box,
//   CircularProgress,
//   Grid,
//   TextField,
//   Button,
//   Snackbar,
//   Alert,
// } from "@mui/material";
// import debounce from "lodash.debounce";
// import axios from "axios";

// export default function SendNotificationByPinCode({sendnotificationopenmodel,
//   setSendnotificationopenmodel}) {
//   const [formData, setFormData] = useState({
//     pincodes: [],
//     title: "",
//     body: "",
//   });

//   const [pincodes, setPincodes] = useState([]);
//   const [pincodeLoading, setPincodeLoading] = useState(false);
//   const [submitting, setSubmitting] = useState(false);
//   const [snackbar, setSnackbar] = useState({
//     open: false,
//     message: "",
//     severity: "success",
//   });

//   const fetchPincodes = debounce(async (searchTerm) => {
//     if (!searchTerm) return;
//     setPincodeLoading(true);
//     try {
//       const response = await axios.get(
//         `https://api.medstown.com/offer/pincode?search=${searchTerm}`
//       );
//       setPincodes(response.data);
//     } catch (err) {
//       console.error("Error fetching pincodes:", err);
//     } finally {
//       setPincodeLoading(false);
//     }
//   }, 500);
//   const handleSubmit = async () => {
//     if (!formData.pincodes.length) {
//       setSnackbar({
//         open: true,
//         message: "❌ Please select at least one pincode.",
//         severity: "error",
//       });
//       return;
//     }

//     const payload = {
//       pincodeArray: formData.pincodes.map((item) =>
//         typeof item === "object" ? item.areaPincode : Number(item)
//       ),
//       title: formData.title,
//       body: formData.body,
//     };

//     // console.log("Payload to send:", payload);

//     setSubmitting(true);
//     try {
//       const response = await axios.post(
//         "https://api.medstown.com/customer/pincodes-notification",
//         payload
//       );

//       const outerMessage = response.data.message;
//       const nestedData = response?.data?.data || {};
//       const {
//         successCount = 0,
//         failureCount = 0,
//         message: innerMessage,
//       } = nestedData;

//       let toastMessage = "";

//       if (successCount === 0 && failureCount === 0) {
//         toastMessage = `⚠️ ${innerMessage || outerMessage}`;
//       } else {
//         toastMessage = `✅ ${outerMessage} (✔ ${successCount}, ❌ ${failureCount})`;
//       }

//       setSnackbar({
//         open: true,
//         message: toastMessage,
//         severity: successCount > 0 ? "success" : "warning",
//       });
//          // ✅ Close modal if notification sent
//     if (successCount > 0 && typeof onClose === "function") {
//       setSendnotificationopenmodel(false);
//     }
//     } catch (error) {
//       console.error("Error sending notification:", error);
//       setSnackbar({
//         open: true,
//         message: "❌ Failed to send notification.",
//         severity: "error",
//       });
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   return (
//     <Box p={2}>
//       <Grid container spacing={2}>
//         <Grid item xs={12}>
//           <Autocomplete
//             multiple
//             options={pincodes}
//             getOptionLabel={(option) => `${option.areaPincode}`}
//             onInputChange={(_, value) => fetchPincodes(value)}
//             onChange={(_, selectedPincodes) =>
//               setFormData((prev) => ({
//                 ...prev,
//                 pincodes: selectedPincodes,
//               }))
//             }
//             loading={pincodeLoading}
//             renderInput={(params) => (
//               <TextField
//                 {...params}
//                 label="Select Pincodes"
//                 variant="outlined"
//                 InputProps={{
//                   ...params.InputProps,
//                   endAdornment: (
//                     <>
//                       {pincodeLoading ? <CircularProgress size={20} /> : null}
//                       {params.InputProps.endAdornment}
//                     </>
//                   ),
//                 }}
//               />
//             )}
//           />
//         </Grid>

//         <Grid item xs={12}>
//           <TextField
//             fullWidth
//             label="Title"
//             value={formData.title}
//             onChange={(e) =>
//               setFormData((prev) => ({ ...prev, title: e.target.value }))
//             }
//           />
//         </Grid>

//         <Grid item xs={12}>
//           <TextField
//             fullWidth
//             multiline
//             rows={3}
//             label="Message Body"
//             value={formData.body}
//             onChange={(e) =>
//               setFormData((prev) => ({ ...prev, body: e.target.value }))
//             }
//           />
//         </Grid>

//         <Grid item xs={12}>
//           <Button
//             variant="contained"
//             color="primary"
//             onClick={handleSubmit}
//             disabled={submitting}
//           >
//             {submitting ? "Sending..." : "Send Notification"}
//           </Button>
//         </Grid>
//       </Grid>

//       {/* Snackbar for feedback */}
//       <Snackbar
//         open={snackbar.open}
//         autoHideDuration={6000}
//         onClose={() => setSnackbar({ ...snackbar, open: false })}
//         anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
//       >
//         <Alert
//           onClose={() => setSnackbar({ ...snackbar, open: false })}
//           severity={snackbar.severity}
//           variant="filled"
//           sx={{ width: "100%" }}
//         >
//           {snackbar.message}
//         </Alert>
//       </Snackbar>
//     </Box>
//   );
// }

import React, { useState } from "react";
import {
  Autocomplete,
  Box,
  CircularProgress,
  Grid,
  TextField,
  Button,
  Snackbar,
  Alert,
} from "@mui/material";
import debounce from "lodash.debounce";
import axios from "axios";

export default function SendNotificationByPinCode({
  sendnotificationopenmodel,
  setSendnotificationopenmodel,
}) {
  const [formData, setFormData] = useState({
    pincodes: [],
    title: "",
    body: "",
  });

  const [pincodes, setPincodes] = useState([]);
  const [pincodeLoading, setPincodeLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
    successCount: 0,
    failureCount: 0,
  });

  const fetchPincodes = debounce(async (searchTerm) => {
    if (!searchTerm) return;
    setPincodeLoading(true);
    try {
      const { data } = await axios.get(
        `https://api.medstown.com/offer/pincode?search=${searchTerm}`
      );
      setPincodes(data);
    } catch (err) {
      console.error("Error fetching pincodes:", err);
    } finally {
      setPincodeLoading(false);
    }
  }, 500);

  const handleSnackbarClose = () =>
    setSnackbar((prev) => ({ ...prev, open: false }));

  const handleSubmit = async () => {
    const { pincodes, title, body } = formData;

    if (!pincodes.length || !title.trim() || !body.trim()) {
      setSnackbar({
        open: true,
        message: "❌ All fields are required.",
        severity: "error",
        successCount: 0,
        failureCount: 0,
      });
      return;
    }

    const payload = {
      pincodeArray: pincodes.map((item) =>
        typeof item === "object" ? item.areaPincode : Number(item)
      ),
      title,
      body,
    };

    setSubmitting(true);
    try {
      const response = await axios.post(
        "https://api.medstown.com/customer/pincodes-notification",
        payload
      );

      const outerMsg = response.data.message;
      const {
        successCount = 0,
        failureCount = 0,
        message: innerMsg,
      } = response?.data?.data || {};

      const message =
        successCount === 0 && failureCount === 0
          ? `⚠️ ${innerMsg || outerMsg}`
          : `✅ ${outerMsg} (✔ ${successCount}, ❌ ${failureCount})`;

      setSnackbar({
        open: true,
        message,
        severity: successCount > 0 ? "success" : "warning",
        successCount,
        failureCount,
      });

      if (successCount > 0) {
        setTimeout(() => {
          setSendnotificationopenmodel(false);
        }, 4000); 
      }
    } catch (error) {
      console.error("Error sending notification:", error);
      setSnackbar({
        open: true,
        message: "❌ Failed to send notification.",
        severity: "error",
        successCount: 0,
        failureCount: 0,
      });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Box p={2}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Autocomplete
            multiple
            options={pincodes}
            getOptionLabel={(option) => `${option.areaPincode}`}
            onInputChange={(_, value) => fetchPincodes(value)}
            onChange={(_, selected) =>
              setFormData((prev) => ({ ...prev, pincodes: selected }))
            }
            loading={pincodeLoading}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Search Pincodes"
                variant="outlined"
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <>
                      {pincodeLoading && <CircularProgress size={20} />}
                      {params.InputProps.endAdornment}
                    </>
                  ),
                }}
              />
            )}
          />
        </Grid>

        <Grid item xs={12}>
          <TextField
            fullWidth
            label="Title"
            value={formData.title}
            onChange={(e) =>
              setFormData((prev) => ({ ...prev, title: e.target.value }))
            }
          />
        </Grid>

        <Grid item xs={12}>
          <TextField
            fullWidth
            multiline
            rows={3}
            label="Message Body"
            value={formData.body}
            onChange={(e) =>
              setFormData((prev) => ({ ...prev, body: e.target.value }))
            }
          />
        </Grid>

        <Grid item xs={12}>
          <Button
            variant="contained"
            color="primary"
            onClick={handleSubmit}
            disabled={submitting}
          >
            {submitting ? "Sending..." : "Send Notification"}
          </Button>
        </Grid>

        {/* Show counts below button if snackbar is open and counts are available */}
        {snackbar.open &&
          (snackbar.successCount > 0 || snackbar.failureCount > 0) && (
            <Grid item xs={12}>
              <Box
                mt={1}
                p={1}
                border="1px solid"
                borderColor="grey.400"
                borderRadius={1}
                textAlign="center"
              >
                <strong>Success Count:</strong> {snackbar.successCount}{" "}
                &nbsp;&nbsp;
                <strong>Failure Count:</strong> {snackbar.failureCount}
              </Box>
            </Grid>
          )}
      </Grid>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbar.severity}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
}
